import { ReportsDetailGraphicSchemaValues } from '@vision/ui/interfaces';
import { ContentCategorySelection } from '@vision/ui/pages/ReportsDetailGraphic/components/ContentCategorySelection/ContentCategorySelection';
import { translateErrorMessage } from '@vision/ui/utils';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { ReportsDetailGraphicCompareLayout } from '../ReportsDetailGraphicCompareLayout';
import { ReportsDetailGraphicBaseProps } from '../report-detail-graphic-compare.util';

interface ReportsDetailGraphicCompareContentCategoryProps extends ReportsDetailGraphicBaseProps {}

export function ReportsDetailGraphicCompareContentCategory({
  required,
}: ReportsDetailGraphicCompareContentCategoryProps) {
  const { t } = useTranslation();
  const formik = useFormikContext<ReportsDetailGraphicSchemaValues>();
  const value = formik.values.selectedCompareCriteria.selectedContentCategoryIds || [];
  const modelId = formik.values.selectedCompareCriteria.selectedContentCategoryAiModelId || null;

  const handleChange = (val: string[]) => {
    formik.setFieldValue('selectedCompareCriteria.selectedContentCategoryIds', val);
  };

  return (
    <ReportsDetailGraphicCompareLayout title={t('contentCategories')}>
      <ContentCategorySelection
        value={value}
        modelId={modelId}
        onChange={handleChange}
        error={translateErrorMessage(formik, 'selectedCompareCriteria.selectedContentCategoryIds')}
        required={required}
        onModelChange={(id) => {
          void formik.setValues({
            ...formik.values,
            selectedCompareCriteria: {
              ...formik.values.selectedCompareCriteria,
              selectedContentCategoryAiModelId: id,
              selectedContentCategoryIds: [],
            },
          });
        }}
      />
    </ReportsDetailGraphicCompareLayout>
  );
}
